













import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import RentList from "./RentList";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class ExtraTax extends Vue {
    @Prop({ type: Object })
    scope: any;


    @Prop({ type: Boolean })
    isClose?: boolean;

    @Prop({ type: [String, Number] })
    extra: any;

    // 判断是否为新增的
    @Prop({ type: Boolean, default: false })
    isNew: any;

    rentList: RentList[] = RentList.list;

    @Watch("scope")
    dataChange(val: any) {
        this.valCopy = val.row[this.extra];
    }

    valCopy: string = this.scope.row[this.extra];

    changeExtra(e: any) {
        this.scope.row[this.extra] = e.target.value;
        this.valCopy = e.target.value;
        this.$emit("change");
    }
    closeAuto() {
        // @ts-ignore
        this.$refs.extraAuto.close();
    }
    beforeDestroy() {
        (<HTMLInputElement>this.$el.querySelector("input")).removeEventListener("change", this.changeExtra);
    }
    mounted() {
        (<HTMLInputElement>this.$el.querySelector("input")).addEventListener("change", this.changeExtra);        
    }

    getOptions() {
        switch (this.extra) {
            case "totalBabyCare": {
                this.extraOptions = [
                    {
                        value: "1个子女,个人承担(2000)",
                        money: "2000"
                    },
                    {
                        value: "1个子女,夫妻均摊(1000)",
                        money: "1000"
                    },
                    {
                        value: "2个子女,个人承担(4000)",
                        money: "4000"
                    },
                    {
                        value: "2个子女,夫妻均摊(2000)",
                        money: "2000"
                    },
                    {
                        value: "3个子女,个人承担(6000)",
                        money: "6000"
                    },
                    {
                        value: "3个子女,夫妻均摊(3000)",
                        money: "3000"
                    }
                ];
                break;
            }
            case "totalChildEducationFee": {
                this.extraOptions = [
                    {
                        value: "1个子女,个人承担(2000)",
                        money: "2000"
                    },
                    {
                        value: "1个子女,夫妻均摊(1000)",
                        money: "1000"
                    },
                    {
                        value: "2个子女,个人承担(4000)",
                        money: "4000"
                    },
                    {
                        value: "2个子女,夫妻均摊(2000)",
                        money: "2000"
                    },
                    {
                        value: "3个子女,个人承担(6000)",
                        money: "6000"
                    },
                    {
                        value: "3个子女,个人承担(4000)",
                        money: "4000"
                    },
                    {
                        value: "3个子女,个人承担(2000)",
                        money: "2000"
                    }
                ];
                break;
            }
            case "totalContinueEducationFee": {
                this.extraOptions = [
                    {
                        value: "学历/学位教育(400)",
                        money: "400"
                    },
                    {
                        value: "职业资格教育(3600)",
                        money: "3600"
                    }
                ];
                break;
            }
            case "totalMortgageInterest": {
                this.extraOptions = [
                    {
                        value: "个人承担(1000)",
                        money: "1000"
                    },
                    {
                        value: "夫妻均摊(500)",
                        money: "500"
                    }
                ];
                break;
            }
            case "totalRent": {
                this.extraOptions = [
                    {
                        value: "直辖市、省会（首府）城市、计划单列市以及国务院确定的其他城市(1500)",
                        money: "1500"
                    },
                    {
                        value: "除第一项所列城市以外，市辖区户籍人口超过100万的城市(1100)",
                        money: "1100"
                    },
                    {
                        value: "市辖区户籍人口不超过100万(含)的城市(800)",
                        money: "800"
                    }
                ];
                if (this.isNew) {
                    if (this.$store.state.accountBook.area != "全国") {
                        for (let i = 0; i < this.rentList.length; i++) {
                            if (this.rentList[i].area === this.$store.state.accountBook.area) {
                                this.scope.row[this.extra] = this.rentList[i].money;
                                this.valCopy = this.rentList[i].money;
                                break;
                            }
                        }
                    }
                }
                break;
            }
            case "totalRaiseElderly": {
                this.extraOptions = [
                    {
                        value: "非独生子女，赡养老人（均摊或指定，不超过1500）",
                        money: "1500"
                    },
                    {
                        value: "独生子女，赡养老人（3000）",
                        money: "3000"
                    }
                ];
                break;
            }
        }
    }

    // 搜索子女教育候选
    extraOptions: any[] = [
        {
            value: "1个子女,个人承担(1000)",
            money: "1000"
        },
        {
            value: "1个子女,夫妻均摊(500)",
            money: "500"
        },
        {
            value: "2个子女,个人承担(2000)",
            money: "2000"
        },
        {
            value: "2个子女,夫妻均摊(1000)",
            money: "1000"
        }
    ];
    searchChild(query: string, cb: any) {
        this.getOptions();
        cb(this.extraOptions);
    }
    selectChild(val: any, row: any) {
        row[this.extra] = val.money;
        this.valCopy = val.money;
        this.$emit("change");
    }

}
